import { ACTION_TYPES } from '~/core/constants'

const { APP } = ACTION_TYPES

export const setInitData = payload => ({
  type: APP.SET_INIT_DATA,
  payload
})

export const setLocale = locale => ({
  type: APP.SET_LOCALE,
  payload: locale
})

export const setUserInfo = userInfo => ({
  type: APP.SET_USER_INFO,
  payload: userInfo
})
